import { SESSION_TOKEN } from '@/utils/constants'
import { Capacitor } from '@capacitor/core'

import axios from 'axios'

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1'

const platform = Capacitor.getPlatform()

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem(SESSION_TOKEN)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    config.headers['X-Platform'] = platform

    return config
  },
  error => Promise.reject(error)
)

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem(SESSION_TOKEN)
    }

    return Promise.reject(error)
  }
)

export default api